import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { RoomTypes } from '@weblite/ts-action/room'
import { PaymentsOutlined } from '@mui/icons-material'
import { t } from '$i18n'
import { BottomDrawer } from '$common/bottom-drawer'
import { SecondaryOutlinedButton } from '$common/buttons'

export function AccessToHallRestricted({
  isOpen,
  onClose,
  hallType,
}: {
  isOpen?: boolean
  onClose: () => void
  hallType: RoomTypes
}) {
  return (
    <BottomDrawer isOpen={isOpen || false} onClose={onClose}>
      <Container>
        <IconContainer sx={{ mb: '32px' }}>
          <PaymentsOutlined
            sx={{ width: '64px', height: '64px', color: 'primary500' }}
          />
        </IconContainer>

        <TextsContainer sx={{ mb: '28px' }}>
          <Typography variant="h2" textAlign="center">
            {t('hallRestrictedModal.title')(
              t(hallType === 'GROUP' ? 'common.group' : 'common.channel'),
            )}
          </Typography>
          <Typography variant="paragraph1" textAlign="center">
            {t('hallRestrictedModal.description')}
          </Typography>
        </TextsContainer>

        <Footer>
          <SecondaryOutlinedButton
            onClick={onClose}
            text={t('hallRestrictedModal.buttonText')}
            fullWidth
          />
        </Footer>
      </Container>
    </BottomDrawer>
  )
}

const Container = styled('div')`
  padding: 32px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const IconContainer = styled('div')`
  width: 100px;
  height: 100px;
  background-color: ${({ theme }) => theme.palette.primary50};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const TextsContainer = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
`

const Footer = styled('div')`
  padding-top: 20px;
  width: 100%;
`
